const isQuarterOpened = ({ quarter, year, quarterNumber }) => quarter.year === year && quarter.number === quarterNumber;

export const getOpenedQuarters  = (quartersArray, openedQuarters) => new Promise((resolve) => {
  const newOpenedQuartersList = {};

  Promise.all(quartersArray.map((quarter) => {
    openedQuarters.map((openedQuarter) => {
      if (isQuarterOpened({ quarter: openedQuarter, year: quarter.start.year(), quarterNumber: quarter.start.quarter() })) {
        newOpenedQuartersList[quarter.start.format('YYYY-MM-DD')] = true;
      }
    });
  })).then(() => resolve(newOpenedQuartersList));
});



// WEBPACK FOOTER //
// ./app/lib/openedQuarters.js